/**
 * Sipariş görselleştirme bileşenleri için yardımcı fonksiyonlar
 */

/**
 * Para birimini formatlar
 * @param {number} value - Formatlanacak değer
 * @returns {string} - Formatlanmış para birimi
 */
export function formatCurrency(value) {
    if (!value && value !== 0) return '-';

    return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2,
    }).format(value);
}

/**
 * Dakika cinsinden süreyi "X saat Y dakika" formatında döndürür
 * @param {number} minutesValue - Dakika cinsinden süre
 * @returns {string} - Formatlanmış süre
 */
export function formatMinutes(minutesValue) {
    if (!minutesValue && minutesValue !== 0) return '-';

    const m = Math.round(minutesValue);
    const hours = Math.floor(m / 60);
    const mins = m % 60;
    if (hours === 0) {
        return `${mins} dk`;
    }
    return `${hours}sa ${mins}dk`;
}

/**
 * ISO tarih formatını "4 Nisan 2025" formatına dönüştürür
 * @param {string} isoDate - ISO formatında tarih
 * @param {boolean} includeUretilecek - "üretilecek" ifadesini ekle
 * @returns {string} - Formatlanmış tarih
 */
export function formatTurkishDate(isoDate, includeUretilecek = false) {
    if (!isoDate) return '-';

    const date = new Date(isoDate);

    // Ay isimleri - Türkçe
    const aylar = [
        'Ocak',
        'Şubat',
        'Mart',
        'Nisan',
        'Mayıs',
        'Haziran',
        'Temmuz',
        'Ağustos',
        'Eylül',
        'Ekim',
        'Kasım',
        'Aralık',
    ];

    const gun = date.getDate();
    const ay = aylar[date.getMonth()];
    const yil = date.getFullYear();

    return includeUretilecek ? `${gun} ${ay} ${yil}'de üretilecek` : `${gun} ${ay} ${yil}`;
}

/**
 * Üretim oranını yüzde olarak formatlar
 * @param {number} oran - Üretim oranı
 * @returns {string} - Formatlanmış oran
 */
export function formatUretimOrani(oran) {
    if (!oran && oran !== 0) return '';

    return `(%${oran.toFixed(2)})`;
}

/**
 * Verileri JSON formatında düzenli gösterir
 * @param {Object} data - Formatlanacak veri
 * @returns {string} - Düzenli JSON string
 */
export function formatJSON(data) {
    if (!data) return '';
    try {
        return JSON.stringify(data, null, 2);
    } catch (error) {
        console.error('JSON formatlarken hata:', error);
        return String(data);
    }
}

/**
 * Bir metni belirli uzunlukta keser ve sonuna ... ekler
 * @param {string} text - Kesilecek metin
 * @param {number} length - Maksimum karakter sayısı
 * @returns {string} - Kesilmiş metin
 */
export function truncateText(text, length = 30) {
    if (!text) return '';
    if (text.length <= length) return text;

    return text.substring(0, length) + '...';
}

/**
 * İki tarih arasındaki farkı hesaplar
 * @param {string|Date} startDate - Başlangıç tarihi
 * @param {string|Date} endDate - Bitiş tarihi
 * @returns {string} - Gün veya saat cinsinden fark
 */
export function dateDiff(startDate, endDate) {
    if (!startDate || !endDate) return 'Belirtilmemiş';

    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffTime = Math.abs(end - start);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays > 0) {
        return `${diffDays} gün`;
    }

    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    return `${diffHours} saat`;
}
